import { createFileRoute, notFound } from '@tanstack/react-router';
import { SupportTicketDetailPage } from '@/pages/help/SupportTicketDetailPage';

export const Route = createFileRoute('/$slug/help/tickets/$ticketId/')({
  // Zammad ids are numeric; a non-numeric path segment can never resolve, so
  // reject it here instead of sending NaN to the API.
  parseParams: ({ ticketId }) => {
    const parsed = Number(ticketId);
    if (!Number.isInteger(parsed) || parsed <= 0) throw notFound();
    return { ticketId: parsed };
  },
  component: RouteComponent
});

function RouteComponent() {
  const { ticketId } = Route.useParams();
  return <SupportTicketDetailPage ticketId={ticketId} />;
}
